import cookie from 'react-cookies'
 

export const get = (name) => {
	return cookie.load(name)
}

export const set = (name, value) => {
	cookie.save(name, value, {path: '/'})
}

export const setWithExpirationDate = (name, value, expirationDate) => {
	cookie.save(name, value, {path: '/', expires: expirationDate})
}


export const remove = (name) => {
	cookie.remove(name)
}